module.exports = __webpack_public_path__ + "img/baseball.2494970f.jpg";